import '../components/hs-chart-pie';
import '../components/hs-sticky-block';
import '../components/hs-fancybox';
import '../components/hs-validation';
import '../components/vendor/appear';

export default {
  init() {
    // JavaScript to be fired on the home page

  },
  finalize() {
    // Open profile info collection panel after a wait if profile data is missing
    // and not on the edit-profile page
    
    if( (typeof mup == 'undefined')){
      $('#welcome_back_popup').modal('show'); // welcome back popup open
    }
    
    if( (typeof mup !== 'undefined')
      && (!$('body').hasClass('page-edit-profile-data')) ){

      $(".profile-main-div").attr('style','background: #e5e7e8 !important;border-radius:0.50rem');  
      $(".button-close-popup").hide(); // hide close button in popup  
      $(".op_display").removeAttr('style'); // remove extra css
      $('#welcome_back_popup').modal('hide'); // welcome back popup open
      $('#profile_popup').modal({
        backdrop: 'static',
        keyboard: false
      }); //open popup
      $("#profile_update_dropdown").find(".form-control").attr("style","height:40px;padding:10px");
      $("#profile_update_dropdown").find(".form-label").attr("style","font-weight:normal");
      
      $("#profile_update_dropdown").find(".aboutYou").removeAttr("style");
      
      
      $("#profile_popup").find(".text-muted").hide(); // hide all subtext 

    }


    $.HSCore.components.HSValidation.init('.js-popprofile-validate', {
      // Currently not being used but leaving as an example
      setDefaults: {
        ignore: [],
        doNotHideMessage: true,
      },
      rules: {
        startDateCalendar: {
          required: true
        },
        postcode: {
          remote:function() {
            $("#loading_button").show(); 
            $("#loading_button").removeClass('d-none'); //Loading button show
            $("#profileInfoCollectionSubmit").hide(); //hide submit button
            
            $.ajax({
            url: ajaxdta.ajaxurl,
            data: ({
              'action': "verify_australian_postcode",
              'nonce': ajaxdta._nonce,
              postcode: function() {
                $("#loading_button").addClass('d-none'); //hide loading button
                $("#profileInfoCollectionSubmit").show(); //showing submit button
               
                return $( "#postcode" ).val();
              }
            }),
          })
          }
        },
        'response_populations[]': {
          required: true
        }
      },
      errorPlacement: function (error, element) { // render error placement for each input type
        if (element.parents('.form-check').size() > 0) {
          error.appendTo(element.parents('.form-check').attr("data-error-container"));
        }
        if (element.parents('.choice').size() > 0) {
          error.appendTo(element.parents('.choice').attr("data-error-container"));
        } else {
          error.insertAfter(element); // for other inputs, just perform default behavior
        }
      },
      submitHandler: function (form) {
        $("#loading_button").show(); 
        $("#loading_button").removeClass('d-none'); //Loading button show
        $("#profileInfoCollectionSubmit").hide(); //hide submit button
        
        $.ajax({
          url: $(form).attr('action'),
          type: $(form).attr('method'),
          data: $(form).serializeArray(),
          dataType: 'json',
          // Set ajax_result message
          success: function (response) {
            $("#loading_button").addClass('d-none'); //hide loading button
            $("#profileInfoCollectionSubmit").show(); //showing submit button
            
            if ( response.success ) {
              $('#popProfileFormAlert').find('.response-message').addClass('alert-success');
            }
            else {
              $('#popProfileFormAlert').find('.response-message').addClass('alert-danger');
            }
            if($("#downloadId").val() != 0){
                 var redirectResourceLink = $("#redirectResourceLink").val();
                $('#popProfileFormAlert').find('.response-message').html("Thanks - We\'ve updated your details. One moment whilst we redirect you...");
                window.setTimeout(function(){window.location.replace(redirectResourceLink)}, 1300);
            }else if($("#redirectURL").val() != ""){ //if redirectURL is set
              // BIZ-864 START If the redirectURL is set, then redirecting to the page after filling the information
                var redirectURL = $("#redirectURL").val();
                $('#popProfileFormAlert').find('.response-message').html("Thanks - We\'ve updated your details. One moment whilst we redirect you...");
                window.setTimeout(function(){window.location.replace(redirectURL)}, 1300);
                // BIZ-864 END If the redirectURL is set, then redirecting to the page after filling the information
            }else{
              $('#popProfileFormAlert').find('.response-message').html('Thanks for your information - we have updated your profile!');
            }
          },
          // For debugging ajax connection issues.
          error: function (jqXHR, textStatus, errorThrown) {
            $("#loading_button").addClass('d-none'); //hide loading button
            $("#profileInfoCollectionSubmit").show(); //showing submit button
            $(form).addClass('fatal-error');
            $("html, body").animate({scrollTop: 0}, 'slow');

            $('#popProfileFormAlert').find('.response-message').addClass('alert-danger');
            $('#popProfileFormAlert').find('.response-message').html('Sorry an unexpected communication error was detected.<br/>Please try again or' +
              ' contact our support team if this continues.');
          },

          // hide spinner and show ajax_result
          complete: function () {
            let displayFeedBack = false;
            if(( ($(form).hasClass('error')) && ($(form).hasClass('js-form-show-errors')) ))
            {
              displayFeedBack = true;
            } else if( $(form).hasClass('fatal-error') ){
              displayFeedBack = true;
            }
            if( displayFeedBack ){
              //if any errors comes up
              $('#popProfileFormAlert').fadeIn('slow');
              $('#popProfileFormAlert').delay(5000).fadeOut('slow');
              $(".op_display").removeAttr('style');  //remove style for all input fields
            }else{
              // if success
              $(".popup_welcome_back").removeClass('disabled');
              $('#popProfileFormAlert').fadeIn('slow');
              $('#popProfileFormAlert').delay(5000).fadeOut('slow');
              $(".profile-main-div").css('background-color','#fff'); // set profile section white bg
              $(".op_display").attr('style','opacity:0.5;pointer-events: none;'); // disabled the profile section
              $("#profileInfoCollectionSubmit").addClass('d-none'); // hide save details button
              $(".edit_profile_enable").removeClass('d-none'); // show edit profile button
            }
          }
        });
        return false; // Don't redirect
      }
    });
    
    // Click on Edit profile then activate profile section and disable what's next div
    $( "#profile_popup" ).on( "click", ".edit_profile_enable", function() {
      $("#profileInfoCollectionSubmit").removeClass('d-none');// show save details button
      $(".edit_profile_enable").addClass('d-none'); // hide edit profile button
      $(".profile-main-div").css('background-color','#e5e7e8'); // shows as selected 
      $(".op_display").removeAttr('style'); //active profile section
    });

    /* if occupation selected Others then display others box to enter*/
    if($('#occupation').val() == 'other (occupation not listed)'){
      $(".occupation_others_div").removeClass('d-none');
      $(".occupation_main_div").addClass('col-sm-4');
      $(".occupation_main_div").removeClass('col-sm-6');
      $(".caresettings_main_div").addClass('col-sm-4');
      $(".caresettings_main_div").removeClass('col-sm-6');
      
      
    }
    // Show selected occupation categories
    $('#occupation').on('change', function () { // TODO This stopped working
      const occupation_value = $(this).val(); // get the dropdown value
      //BIZ_823 START: Making occupation_others element null only if profilevalidation
      var profileValidationClick = $(".profileValidation");
      if(!profileValidationClick.data('clicked')) {
        $("#occupation_others").val('');
      }
      //BIZ_823 START: Making occupation_others element null only if profilevalidation
      $(".occupation_others_div").addClass('d-none'); // by default others field hide
      $(".occupation_main_div").removeClass('col-sm-4');
      $(".occupation_main_div").addClass('col-sm-6');
      $(".caresettings_main_div").removeClass('col-sm-4');
      $(".caresettings_main_div").addClass('col-sm-6');

      if(occupation_value == 'other (occupation not listed)'){
          $(".occupation_others_div").removeClass('d-none');
          $(".occupation_main_div").addClass('col-sm-4');
          $(".occupation_main_div").removeClass('col-sm-6');
          $(".caresettings_main_div").addClass('col-sm-4');
          $(".caresettings_main_div").removeClass('col-sm-6');
      }

    });

    const country = $('#countryselect').val();
    if(country != "Australia"){
      $(".country_inter").removeClass('col-sm-4');
      $(".country_inter").addClass('col-sm-3');
      $("#mainpostcodediv").addClass('d-none');
      $("#mainstatediv").addClass('d-none');
      $("#statediv").addClass('d-none');
      $('#state option').each(function() {

        if ( $(this).val() == '' ) {
          $(this).prop('selected', true);
        }else { 
          $(this).prop('selected', false);
        }  
      });

      $('#state').data('rule-required',false);
      $("#postcodediv").addClass('d-none');
      $("#postcode").val('');
      $('#postcode').data('rule-required',false);

    }else{
      $(".country_inter").addClass('col-sm-4');
      $(".country_inter").removeClass('col-sm-3');
    }

    $('#countryselect').on('change', function () {
      const country_value = $(this).val();
      if(country_value != "Australia"){
        $(".country_inter").removeClass('col-sm-4');
        $(".country_inter").addClass('col-sm-3');
        $("#mainpostcodediv").addClass('d-none');
        $("#mainstatediv").addClass('d-none');
        $("#statediv").addClass('d-none');
        $('#state option').each(function() {

          if ( $(this).val() == '' ) {
              $(this).prop('selected', true);
          }else { 
              $(this).prop('selected', false);
          }  

        });
        $('#state').data('rule-required',false);
        $("#postcodediv").addClass('d-none');
        $("#postcode").val('');
        $('#postcode').data('rule-required',false);
      }else{
        $(".country_inter").addClass('col-sm-4');
        $(".country_inter").removeClass('col-sm-3');
        $("#mainpostcodediv").removeClass('d-none');
        $("#mainstatediv").removeClass('d-none');
        $("#statediv").removeClass('d-none');
        $("#postcodediv").removeClass('d-none');
        $('#state').data('rule-required',true);
        $('#postcode').data('rule-required',true);
      }
    });

    $(".popup_welcome_back").on('click', function(){
      const preferredName = $('#firstNameInput').val();
      const lastName = $('#lastNameInput').val();
      $('#profile_popup').modal('hide');
      $(".button-close-popup").show(); // show close button in popup  
      $('.welcome-back').text(`Welcome ${preferredName.trim()}!`);
      $('.toggle-text').text(preferredName.trim());
      $('.display_name_text').text(`${preferredName.trim()} ${lastName.trim()}`);
      $('#welcome_back_popup').modal('show');
    });

    $('.close-btn-cs').on("click", () => {
      $('.coming-soon-banner').addClass('d-none');
      document.cookie = 'bannerShown=true;';
    });

    $(function(){
      //
      const checkCookie = (cookieName) => {
        const cookies = document.cookie.split(';').map(cookie => cookie.trim());
        // returns false if no cookie available and returns true if cookie does exist
        return cookies.some(cookie => cookie.startsWith(`${cookieName}=`));
      };
      
      // Check if the 'bannerShown' cookie exists
      if (!checkCookie('bannerShown')){
          // If the 'bannerShown' cookie does not exists, show the banner
          $('.coming-soon-banner').removeClass('d-none');
      }
    });
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js